import { render, staticRenderFns } from "./Feature2.vue?vue&type=template&id=84d02e64"
import script from "./Feature2.vue?vue&type=script&lang=js"
export * from "./Feature2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports